<template>
  <section class="five-card-hands-for-category">
    <div
      v-for="fiveCardHand in visibleFiveCardHands"
      v-bind:key="fiveCardHand.id + '-' + playerState.name"
      class="five-card-hand-container"
      v-on:mouseover="$emit('fiveCardHandMouseover', fiveCardHand.matchingSpecificHands)"
      v-on:mouseleave="$emit('fiveCardHandMouseleave')"
    >
      <span class="left-container" v-bind:class="'level-' + fiveCardHand.level">
        <span
          class="glyphicon"
          v-bind:class="{
            'visibility-hidden': !fiveCardHand.children,
            'glyphicon-triangle-bottom': !fiveCardHand.collapsed,
            'glyphicon-triangle-right': fiveCardHand.collapsed,
          }"
          v-on:click="$emit('toggleCollapsedValueOfFiveCardHandParent', fiveCardHand)"
        ></span>
        <input
          type="checkbox"
          v-bind:id="playerState.name + '-' + fiveCardHand.id + '-checkbox-' + random"
          v-bind:disabled="!playerState.hasSimulationBeenRun || !authorized"
          v-bind:checked="fiveCardHand.checked"
          v-bind:indeterminate.prop="fiveCardHand.checked === 'partially'"
          v-on:change="$emit('setCheckedValueOfFiveCardHand', {
            fiveCardHandId: fiveCardHand.id,
            newCheckedValue: $event.target.checked,
          })"
        >
        <label
          v-html="getFiveCardHandText(fiveCardHand)"
          v-bind:for="playerState.name + '-' + fiveCardHand.id + '-checkbox-' + random"
          class="text"
        ></label>
      </span>
      <span v-if="playerState.hasSimulationBeenRun && !hideRightContainer" class="right-container" v-on:click="expandFiveCardHandWeightModal(fiveCardHand)">
        <five-card-hand-bar
          v-bind:type="type"
          v-bind:probability="fiveCardHand.probability.roundToOneDecimalPlace()"
          v-bind:numCombos="fiveCardHand.getNumCombos(playerState.generalHands.numberOfPossibleSpecificHands)"
          v-bind:percentagesOrCombos="percentagesOrCombos"
          v-bind:percentageOfSpecificHandsThatAreSelected="fiveCardHand.percentageOfSpecificHandsThatAreSelected"
        />
        <span v-if="percentagesOrCombos === 'percentages' && fiveCardHand.probability < 20" class="probability">
          {{ fiveCardHand.probability.roundToOneDecimalPlace() }}%
        </span>
        <span v-if="percentagesOrCombos === 'combos' && fiveCardHand.probability < 15" class="num-combos">
          {{ fiveCardHand.getNumCombos(playerState.generalHands.numberOfPossibleSpecificHands) }}
        </span>
      </span>
    </div>
    <five-card-hand-weight-modal
      v-bind:fiveCardHand="fiveCardHandThatTriggeredTheFiveCardHandWeightModal"
      v-on:updateWeightOfFiveCardHand="$emit('updateWeightOfFiveCardHand', $event)"
      v-on:applyExactWeightToFiveCardHand="$emit('applyExactWeightToFiveCardHand', $event)"
    />
  </section>
</template>

<script>
import FiveCardHandBar from '@/components/five-card-hands-section/five-card-hand-bar';
import FiveCardHandWeightModal from '@/components/five-card-hands-section/five-card-hand-weight-modal';

export default {
  name: 'five-card-hands-for-category',
  components: {
    'five-card-hand-bar': FiveCardHandBar,
    'five-card-hand-weight-modal': FiveCardHandWeightModal,
  },
  props: [
    'type',
    'playerState',
    'percentagesOrCombos',
    'hideRightContainer',
    'shortDeck',
    'authorized',
  ],
  data: function () {
    return {
      fiveCardHandThatTriggeredTheFiveCardHandWeightModal: null,
      random: Math.random(),
    };
  },
  computed: {
    visibleFiveCardHands: function () {
      if (this.type === 'made-hands') {
        if (this.shortDeck) {
          return this.playerState.fiveCardHands.shortDeckVisibleMadeHands;
        } else {
          return this.playerState.fiveCardHands.visibleMadeHands;
        }
      } else if (this.type === 'draws') {
        return this.playerState.fiveCardHands.visibleDraws;
      } else if (this.type === 'combos') {
        return this.playerState.fiveCardHands.visibleCombos;
      }
    },
  },
  methods: {
    getFiveCardHandText: function (fiveCardHand) {
      // fiveCardHand.text + ': <small><em>(' + fiveCardHand.weight + '%)</em></small>

      if (fiveCardHand.hasExplicitWeight) {
        return `${fiveCardHand.text} <small title="Weight" style="color: gray;"><em>(${fiveCardHand.weight}%):</em></small>`;
      }

      return `${fiveCardHand.text}:`;
    },
    expandFiveCardHandWeightModal: function (fiveCardHand) {
      if (!this.authorized) {
        return;
      }

      this.fiveCardHandThatTriggeredTheFiveCardHandWeightModal = fiveCardHand;
      $(this.$el).find('.five-card-hand-weight-modal').modal();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "src/assets/mixins";

  .five-card-hand-container .five-card-hand-container:first-of-type, .col-sm-4 .five-card-hand-container:first-of-type {
    margin-top: 5px;
  }

  .glyphicon {
    color: lightgray;
    cursor: pointer;
  }

  .five-card-hand-container {
    @include noselect();
    white-space: nowrap;
    margin-bottom: 3px;

    .left-container {
      display: inline-block;
      white-space: nowrap;
      width: 130px;
      margin-right: 5px;

      .glyphicon-triangle-bottom, .glyphicon-triangle-right {
        display: inline-block;
        width: 12px;
      }

      input[type="checkbox"] {
        margin-right: 3px;
      }

      .text {
        font-weight: normal;
        margin-bottom: 0px;
        white-space: normal;
        display: inline-block;
        width: 105px;
        cursor: pointer;
      }

      .has-weight {
        font-style: italic;
      }

      &.level-1 {
        padding-left: 1em;
      }

      &.level-2 {
        padding-left: 2em;
      }
    }

    .right-container {
      display: inline-block;
      font-size: 10px;
      vertical-align: middle;
      cursor: context-menu;

      .probability, .num-combos {
        margin-left: 1px;
        vertical-align: top;
      }

      .weight {
        font-style: italic;
      }
    }

    .glyphicon-scale {
      display: none;
    }
  }

  @media (max-width: 425px) {
    .glyphicon {
      display: inline-block;
      padding: 1em 1.5em;
    }

    .level-1 {
      padding-left: 2.5em;
    }

    .level-2 {
      padding-left: 5em;
    }

    .five-card-hand-container .five-card-hand-container:first-of-type {
      margin-top: 13px;
    }
  }

  @media (max-device-width: 460px) {
    .five-card-hand-container .glyphicon-scale {
      display: inline;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/five-card-hands-section/five-card-hands-for-category.vue